import { useTranslation } from 'react-i18next'
import { useCookieConsent } from './CookieConsentContext'

/** Impressum/Datenschutzerklärung are rendered as app pages (see LegalPage.tsx) rather than static
 *  .txt files - serving plain text without an explicit charset let some browsers guess the wrong
 *  encoding and mangle umlauts. Shared between LandingPage's footer and the logged-in app shell's
 *  footer so both surfaces stay reachable without duplicating the markup. Also the one place a
 *  visitor can reopen the cookie-consent banner (see CookieConsentContext.tsx) to change an
 *  earlier decision about Google Analytics, on every page rather than just the marketing footer. */
export function LegalLinks() {
  const { t } = useTranslation()
  const { reopen } = useCookieConsent()
  return (
    <span className="legal-links">
      <a href="/impressum" target="_blank" rel="noopener noreferrer">
        {t('common.legal.impressum')}
      </a>
      <a href="/datenschutzerklaerung" target="_blank" rel="noopener noreferrer">
        {t('common.legal.privacy')}
      </a>
      <button type="button" className="legal-links-cookie-button" onClick={reopen}>
        {t('common.legal.cookieSettings')}
      </button>
    </span>
  )
}
